module.exports = __webpack_public_path__ + "img/tab-02.c0d9499d.png";